import { environment } from '../../../../environments/environment';
import { RouteHelper, RoutePaths } from '@helper/route-paths';
import { LegacyMessageGroupType, LegacySettleStatus } from '@service/legacy/model/legacy-extensions';

// ref app-routing module.
export class LegacyRouteHelper {
  static legacy = 'legacy';
  static question = 'question';

  static legacyLogin(): string {
    return `${this.legacy}/${RoutePaths.LOGIN}`;
  }

  static legacyForgotAccount(): string {
    return `${this.legacy}/${RoutePaths.FORGOT_ACCOUNT}`;
  }

  static legacyForgotPassword(): string {
    return `${this.legacy}/${RoutePaths.FORGOT_PASSWORD}`;
  }

  static legacyResetPassword(memberId: string, serialNo: string): string {
    // 特別備註：限定 legacy domain
    // 此路由與忘記密碼, 使用相同 component. 但多了 memberId, serialNo 參數.
    return `${environment.legacyEndPointUrl}/${this.legacy}/${RoutePaths.RESET_PASSWORD}/${memberId}/${serialNo}`;
  }

  static legacyHome(): string {
    return `${this.legacy}/${RoutePaths.HOME}`;
  }

  static legacyUser(): string {
    return `${this.legacy}/${RoutePaths.USER}`;
  }

  static legacyOrders(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.ORDERS}`;
  }

  static legacyOrderDetail(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.ORDER_DETAIL}/${orderNo}`;
  }

  static legacyLogisticDetail(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.LOGISTICS_DETAIL}/${orderNo}`;
  }

  static legacyApplyReturnFinish(orderId: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.FINISH}/${orderId}`;
  }

  static legacyApplyReturn(orderNo: string, returnId?: string): string {
    return returnId
      ? `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.APPLY}/${orderNo}/${returnId}`
      : `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.APPLY}/${orderNo}`;
  }

  static legacyReturnDetail(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.RETURN_DETAIL}/${orderNo}`;
  }

  static legacyRateDetail(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.RATE_DETAIL}/${orderNo}`;
  }

  static legacyReceiptDetail(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.RECEIPT_DETAIL}/${orderNo}`;
  }

  static legacyNotification(type?: LegacyMessageGroupType): string {
    return type
      ? `${this.legacy}/${RoutePaths.USER}/${RoutePaths.NOTIFICATION}/${type}`
      : `${this.legacy}/${RoutePaths.USER}/${RoutePaths.NOTIFICATION}`;
  }

  static legacyQuestion(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.USER}/${this.question}/${orderNo}`;
  }

  static legacyRefundAccount(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.REFUND_ACCOUNT}`;
  }

  static legacyApplySettlement(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.APPLY_SETTLEMENT}`;
  }

  static legacySettlementRecord(state?: LegacySettleStatus): string {
    if (state) {
      return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.SETTLEMENT_RECORD}/${state}`;
    }
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.SETTLEMENT_RECORD}`;
  }

  static legacyBankAccountList(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.ACCOUNT_LIST}`;
  }

  static legacyCreateRefundAccount(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.ACCOUNT_EDIT}`;
  }

  static legacyCreateApplyAccount(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.APPLY_ACCOUNT}`;
  }

  static legacySelectBankAccount(): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.SELECT_ACCOUNT}`;
  }

  static legacyEditRefundAccount(id: number): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.ACCOUNT_EDIT}/${id}`;
  }

  static legacySelectRefundAccount(id: number): string {
    return `${this.legacy}/${RoutePaths.USER}/${RoutePaths.SELECT_EDIT_ACCOUNT}/${id}`;
  }

  static legacyRefundDetail(orderNo: string): string {
    return `${this.legacy}/${RoutePaths.ORDERS}/${RoutePaths.REFUND_DETAIL}/${orderNo}`;
  }

  static legacyPage(pageId: string): string {
    return `${this.legacy}/${RoutePaths.PAGE}/${RouteHelper.fixedEncodeURIComponent(pageId)}`;
  }

  static legacyCustomerService(orderNo?: string): string {
    return orderNo
      ? `${this.legacy}/${RoutePaths.CUSTOMER_SERVICE}/${orderNo}`
      : `${this.legacy}/${RoutePaths.CUSTOMER_SERVICE}`;
  }

  static supportService(qaType?: string, qaName?: string): string {
    if (qaType) {
      return `${this.legacy}/${RoutePaths.SUPPORT_SERVICE}/${
        qaType === RoutePaths.QA_TYPE_LIST ? qaType : RouteHelper.fixedEncodeURIComponent(qaType)
      }`;
    }
    if (qaName) {
      return `${this.legacy}/${RoutePaths.QA_CONTENT}/${RouteHelper.fixedEncodeURIComponent(qaName)}`;
    }
    return RoutePaths.SUPPORT_SERVICE;
  }
}
